import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { CustomTicketsConnector } from '../../conectors/custom-families.connector';
import { Ticket, TicketWrapper } from '../../model/ticket.model';
import {
  AddTicket,
  AddTicketFail,
  AddTicketSuccess,
  CustomTicketsActionTypes,
  LoadTicket,
  LoadTicketFail,
  LoadTickets,
  LoadTicketsCategoryFail,
  LoadTicketsCategorySuccess,
  LoadTicketsCompanyCategoryFail,
  LoadTicketsCompanyCategorySuccess,
  LoadTicketsFail,
  LoadTicketsSuccess,
  LoadTicketSuccess,
  TicketPage
} from '../actions/custom-ticket.action';

@Injectable()
export class CustomTicketsEffects {
  constructor(private actions$: Actions, private ticketsConnector: CustomTicketsConnector) {}
  protected logger = inject(LoggerService);
  LoadTickets$: Observable<LoadTicketsSuccess | LoadTicketsFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomTicketsActionTypes.LOAD_TICKETS),
      map((action: LoadTickets) => action.payload),
      mergeMap((payload: TicketPage) =>
        this.ticketsConnector.loadTickets(payload.userId, payload.pageSize, payload.currentPage, payload.sort).pipe(
          map((tickets: TicketWrapper) => {
            return new LoadTicketsSuccess(tickets);
          }),
          catchError((error) => of(new LoadTicketsFail({ error: tryNormalizeHttpError(error, this.logger) })))
        )
      )
    )
  );

  LoadTicketsCategory$: Observable<LoadTicketsCategorySuccess | LoadTicketsCategoryFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomTicketsActionTypes.LOAD_TICKETS_CATEGORY),
      mergeMap(() =>
        this.ticketsConnector.loadTicketCategories().pipe(
          map((tickets: any) => {
            return new LoadTicketsCategorySuccess(tickets);
          }),
          catchError((error) => of(new LoadTicketsCategoryFail({ error: tryNormalizeHttpError(error, this.logger) })))
        )
      )
    )
  );

  LoadTicketsCompanyCategory$: Observable<LoadTicketsCompanyCategorySuccess | LoadTicketsCompanyCategoryFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomTicketsActionTypes.LOAD_TICKETS_COMPANY_CATEGORY),
      mergeMap(() =>
        this.ticketsConnector.loadTicketCompanyCategories().pipe(
          map((payload: any) => {
            return new LoadTicketsCompanyCategorySuccess(payload);
          }),
          catchError((error) => of(new LoadTicketsCompanyCategoryFail({ error: tryNormalizeHttpError(error, this.logger) })))
        )
      )
    )
  );

  LoadTicket$: Observable<LoadTicketSuccess | LoadTicketFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomTicketsActionTypes.LOAD_TICKET),
      map((action: LoadTicket) => action.payload),
      mergeMap((payload: { userId: string; ticketId: string }) =>
        this.ticketsConnector.loadTicket(payload.ticketId, payload.userId).pipe(
          map((tickets: any) => {
            return new LoadTicketSuccess(tickets);
          }),
          catchError((error) => of(new LoadTicketFail({ error: tryNormalizeHttpError(error, this.logger) })))
        )
      )
    )
  );

  AddTicket$: Observable<AddTicketSuccess | AddTicketFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomTicketsActionTypes.ADD_TICKET),
      map((action: AddTicket) => action.payload),
      mergeMap((payload: { userId: string; ticket: Ticket }) =>
        this.ticketsConnector.addTicket(payload.ticket, payload.userId).pipe(
          map((ticket: any) => {
            return new AddTicketSuccess(ticket);
          }),
          catchError((error) => of(new AddTicketFail({ error: tryNormalizeHttpError(error, this.logger) })))
        )
      )
    )
  );
}

export const effectsTickets: any[] = [CustomTicketsEffects];
